import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "62",
  height: "20",
  viewBox: "0 0 61 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M39.73.023c-4.332 0-8.199 2.266-8.199 6.454 0 4.8 6.864 5.132 6.864 7.546 0 1.016-1.153 1.926-3.122 1.926-2.796 0-4.886-1.273-4.886-1.273l-.89 4.226s2.405 1.075 5.597 1.075c4.738 0 8.465-2.38 8.465-6.637 0-5.074-6.895-5.395-6.895-7.633 0-.797.945-1.668 2.91-1.668 2.215 0 4.024.922 4.024.922l.875-4.078s-1.97-.86-4.743-.86M.105.332 0 .949s1.82.336 3.465 1.008c2.113.77 2.262 1.219 2.617 2.61l3.879 15.09h5.2L23.167.331H17.98l-5.144 13.14-2.102-11.136C10.543 1.059 9.566.332 8.375.332Zm25.149 0-4.07 19.324h4.949L30.183.332Zm27.586 0c-1.195 0-1.824.645-2.29 1.77l-7.245 17.554h5.187l1.004-2.926h6.316l.61 2.926H61L57.008.332Zm.672 5.223 1.539 7.25h-4.117Zm0 0",
      style: {"stroke":"none","fill-rule":"nonzero","fill":"#1434cb","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }